// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AdminConfigStateMapper from "../../mapper/AdminConfigStateMapper.bs.js";
import * as AdminDetailsStateMapper from "../../mapper/AdminDetailsStateMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

var execute = AdminDetailsStateMapper.execute;

var AdminDetailsResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var AdminDetailsResponseConverter = partial_arg(AdminDetailsResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = AdminConfigStateMapper.execute;

var AdminConfigResponseConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var AdminConfigResponseConverter = partial_arg$1(AdminConfigResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  AdminDetailsResponseConverterConfig ,
  AdminDetailsResponseConverter ,
  AdminConfigResponseConverterConfig ,
  AdminConfigResponseConverter ,
  
}
/* AdminDetailsResponseConverter Not a pure module */
